"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATUS_STALE_DAYS = void 0;
/** 상태를 보고하지 않은 단말을 미가동으로 보는 기준 일수 — 서버 SQL과 화면 안내 문구의 단일 소스 */
exports.STATUS_STALE_DAYS = 7;
